<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { commissionService } from "../../../services/saleservice/commission.service";
import { commissionstatusService } from "../../../services/saleservice/commissionstatus.service";
// import { customertypeService } from "../../../services/contactservice/customertype.service";
// import { propertyService } from "../../../services/propertyservice/property.service";
import { sellerService } from "../../../services/saleservice/seller.service";
import List from "../../../components/list";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Commissions List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      commissionData: {},
      commissionStatusData: {},
      sellerData: {},
      saleData: {},
      propertyData: {},
      fetchingStats: false,
      title: "Commissions List",

    };
  },
  mounted() {
    this.loadingStatusData();
    // this.loadingPropertyData();
    // this.loadingSaleData();
    this.loadingSellerData();
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      commissionService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.commissionData = response;
        });
    },

    // loadingPropertyData: function() {
    //   propertyService.getList('?page=0')
    //     .then(response => {
    //       this.propertyData = response;

    //     });
    // },

    // loadingSaleData: function() {
    //   customertypeService.getList()
    //     .then(response => {
    //       this.saleData = response;

    //     });
    // },

    loadingSellerData: function() {
      sellerService.getList('?page=0')
        .then(response => {
          this.sellerData = response;

        });
    },

    loadingStatusData: function() {
      commissionstatusService.getList('')
        .then(response => {
          this.commissionStatusData = response;

        });
    },

    deleted: function(id) {
      commissionService.remove(id)
        .then(response => {
        
          // this.commissionData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-add",
          });
    },

    moreClick: function(event, id) {

      if(event == 'finish') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('commission.finish-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            commissionService.finish(id).then(response => {
              if(response.status == 200){
                this.loadingData();
              }
            });
            // console.log(id);
          }
        });
      }
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: ''}" :title="$t('commission.text')" />
    <List v-bind:dataList="commissionData" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:deletes="[deleted, null]"
          v-bind:formats="[{name: 'commission', type: 'currency', sign: '$'}, {name: 'pay_date', type: 'date'}, {name: 'status', color: true}, {name: 'commission_paid', type: 'currency', sign: '$'}]"
          v-bind:fields="[ `code: ${$t('commission.code')}`,
            `customer: ${$t('customer.text')}`,  `property: ${$t('property.text')}`, `seller: ${$t('seller.text')}`,
            `commission: ${$t('commission.commission-amount')}`, `commission_paid: ${$t('commission.commission-paid')}`, 
            `pay_date: ${$t('payment.pay_date')}`, `status: ${$t('property.status')}`
          ]" 
          v-bind:view="{link: 'commission-view'}" 
          @more="moreClick"
          v-bind:more="{
            sub: [{
              name: 'invoice.print', icon: 'bx bx-printer', link: 'commission-print', column: 'id', target: '_blank'
            },{
              name: 'commission.finish', icon: 'bx bx-check-double', action: 'finish', column: 'id', show: {column: 'commission_status_id', value: 1}
            },{
              name: 'commission.change-date', icon: 'bx bx-calendar', link: 'commission-edit', column: 'id'
            },{
              name: 'commission.pay', icon: 'bx bx-list-check', link: 'commission-paid', column: 'id', show: {column: 'commission_status_id', value: 1}
            },{
              name: 'commission.pay', icon: 'bx bx-list-check', link: 'commission-paid', column: 'id', show: {column: 'commission_status_id', value: 2}
            }] 
          }"
          v-bind:filter="{
            search: ['commissions.code', 'commissions.name', 'properties.code'],
            dropdown: [{
              title: 'seller.text',
              field: 'commissions.seller_id',
              data: this.sellerData.data,
              width: 2,
            }, {
              title: 'property.status',
              field: 'commissions.commission_status_id',
              data: this.commissionStatusData.data,
              width: 2,
            }],
            date: {
              title: 'general.date',
              field: 'commissions.created_by'
            }
          }"
          
    />      
  </Layout>
</template>